import { render, staticRenderFns } from "./FormPanel.vue?vue&type=template&id=d789f204&scoped=true&"
import script from "./FormPanel.vue?vue&type=script&lang=js&"
export * from "./FormPanel.vue?vue&type=script&lang=js&"
import style0 from "./FormPanel.vue?vue&type=style&index=0&id=d789f204&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d789f204",
  null
  
)

export default component.exports